import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

// D3 (plan 2026-10-27): what the order service will add when this supplier's
// cart becomes an order. Creates nothing. Route de-order-service
// routes/api/cart/preview.ts (ORD_SAVE or ORD_SEND).

export interface ICartPreviewLine {
  variantId: string
  parentVariantId: string
  warehouseId?: string
  quantity: number
  price: number
}

export interface ICartPreviewGift {
  variantId: string
  quantity: number
  promotionId: string
  promotionName: string
}

export interface ICartPreviewApplied {
  promotionId: string
  type: string
  /** 0 for FREE_GOODS. */
  amount: number
  description: string
}

export interface ICartThresholdProgress {
  promotionId: string
  current: number
  target: number
  unit: "QTY" | "AMOUNT"
  /** «5%» or «5,000₮». */
  discountText: string
}

export interface ICartPreview {
  giftLines: ICartPreviewGift[]
  extraOrderDiscount: number
  applied: ICartPreviewApplied[]
  thresholdProgress: ICartThresholdProgress[]
}

export const preview = async (data: { supplierBusinessId: string; lines: ICartPreviewLine[] }): Promise<ICartPreview> => {
  return httpRequest.post("/ord/cart/preview", data as never)
}
